import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Collapse = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M4 7C4.55228 7 5 7.44772 5 8L5 32C5 32.5523 4.55229 33 4 33C3.44772 33 3 32.5523 3 32L3 8C3 7.44772 3.44772 7 4 7ZM20.7071 8.29289C21.0976 8.68342 21.0976 9.31658 20.7071 9.70711L11.4142 19L36 19C36.5523 19 37 19.4477 37 20C37 20.5523 36.5523 21 36 21L11.4142 21L20.7071 30.2929C21.0976 30.6834 21.0976 31.3166 20.7071 31.7071C20.3166 32.0976 19.6834 32.0976 19.2929 31.7071L8.29289 20.7071C8.10536 20.5196 8 20.2652 8 20C8 19.7348 8.10536 19.4804 8.29289 19.2929L19.2929 8.29289C19.6834 7.90237 20.3166 7.90237 20.7071 8.29289Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Collapse;
